import ApiResponse from '~/graphql/wrappers/api-response';
import { type UseQueryState } from '@urql/vue';

export default class QueryResponse<T = Query, V = any> extends ApiResponse<T> {
  constructor(useQueryResponse: UseQueryState<T, V>) {
    super(useQueryResponse.error.value);
    if (useQueryResponse.data.value) {
      this.setData(useQueryResponse.data.value);
    }
  }
}
